import * as React from 'react';

import { ICON_LOOKUP } from './lookup';
type Icon = keyof typeof ICON_LOOKUP;
export type VariantProp = 'green' | 'default';
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, 'ref'> & {
  family?: 'regular' | 'solid';
  icon: Icon;
  size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg';
  ref?: React.RefObject<SVGSVGElement>;
  variant?: VariantProp;
};
type Size = NonNullable<IconProps['size']>;
const SIZES: Record<Size, { width: number | string; height: number | string }> =
  {
    xxs: { height: '1rem', width: '1rem' },
    xs: { height: '1.25rem', width: '1.25rem' },
    sm: { height: '1.5rem', width: '1.5rem' },
    md: { height: '2.25rem', width: '2.25rem' },
    lg: { height: 40, width: 40 },
  };

function Icon({
  family = 'solid',
  icon,
  size,
  id,
  variant,
  ...props
}: IconProps) {
  const Component = ICON_LOOKUP[icon];

  if (!Component) {
    return <>{icon}</>;
  }
  return (
    <Component
      {...props}
      {...(size ? SIZES[size] : {})}
      id={id}
      data-cy={id}
      data-testid={id}
      variant={variant}
    />
  );
}

export default Icon;
